import { connect } from 'react-redux';
import { State } from 'store/state';
import { uploadBulletinReportModalStateSelector } from 'store/state/app/selectors';
import { setReportUploadBulletinPopupState } from 'store/state/app/actions';
import ReportPopupView from './ReportUploadBulletinPopup';
import { reportAddressErrorAction } from 'store/state/uploadBulletin/actions';
import { userProfileSelector } from 'store/state/domainData/selectors';
import { createSelector } from 'reselect';
import { getRouteParams } from 'store/state/selectors/router';

const userEmailSelector = createSelector(userProfileSelector, user => user && user.email);

const mapStateToProps = (state: State) => ({
  email: userEmailSelector(state),
  modalState: uploadBulletinReportModalStateSelector(state),
  routeParams: getRouteParams(state),
});

const mapDispatchToProps = {
  onClosePopup: () => setReportUploadBulletinPopupState(null),
  onSubmit: reportAddressErrorAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportPopupView);
